<template>
  <div class="about-container">
    <!-- 使用公共导航栏组件 -->
    <Nav />

    <!-- 主要内容区域 -->
    <div class="max-w-4xl mx-auto px-4 py-8 mt-20 w-full">
      <!-- 预订详情展示区 -->
      <div class="flex justify-between items-center mb-2">
        <button
          type="button"
          class="text-gray-600 hover:text-primary text-sm font-medium flex items-center"
          @click="goBackToEdit"
        >
          <i class="ri-arrow-left-s-line mr-1"></i> 返回修改
        </button>
      </div>

      <!-- 活动信息板块 - 现在可编辑 -->
      <div
        class="bg-white rounded-xl shadow-sm border border-gray-100 p-6 mb-6"
      >
        <h2 class="text-lg font-semibold text-gray-900 mb-4">活动信息</h2>
        <div class="grid grid-cols-2 gap-4">
          <div class="col-span-2">
            <label class="block text-sm font-medium text-gray-700 mb-2"
              >活动名称 <span class="text-red-500">*</span></label
            >
            <input
              type="text"
              v-model="activityName"
              class="w-full px-3 py-2 border border-gray-300 rounded-lg text-sm focus:ring-2 focus:ring-primary focus:border-transparent"
              placeholder="请输入活动名称"
            />
          </div>
          <div>
            <label class="block text-sm font-medium text-gray-700 mb-2"
              >活动类型 <span class="text-red-500">*</span></label
            >
            <div class="relative">
              <button
                type="button"
                class="activity-type-select w-full px-3 py-2 border border-gray-300 rounded-lg text-sm text-left bg-white flex items-center justify-between cursor-pointer"
                @click.stop="toggleDropdown"
              >
                <span
                  :class="[
                    'selected-text',
                    selectedActivityType ? '' : 'text-gray-500',
                  ]"
                >
                  {{ selectedActivityType || "请选择活动类型" }}
                </span>
                <div class="w-4 h-4 flex items-center justify-center">
                  <i class="ri-arrow-down-s-line text-gray-400"></i>
                </div>
              </button>
              <div
                v-show="dropdownVisible"
                class="activity-type-dropdown absolute top-full left-0 right-0 bg-white border border-gray-300 rounded-lg shadow-lg mt-1 z-10"
              >
                <div class="py-1">
                  <button
                    v-for="type in activityTypes"
                    :key="type"
                    type="button"
                    class="activity-type-option w-full px-3 py-2 text-left text-sm hover:bg-gray-50 cursor-pointer"
                    @click="selectActivityType(type)"
                  >
                    {{ type }}
                  </button>
                </div>
              </div>
            </div>
          </div>
          <div>
            <label class="block text-sm font-medium text-gray-700 mb-2"
              >预计人数 <span class="text-red-500">*</span></label
            >
            <div class="relative">
              <button
                type="button"
                class="activity-type-select w-full px-3 py-2 border border-gray-300 rounded-lg text-sm text-left bg-white flex items-center justify-between cursor-pointer"
                @click.stop="togglePeopleDropdown"
              >
                <span
                  :class="[
                    'selected-text',
                    selectedPeopleCount ? '' : 'text-gray-500',
                  ]"
                >
                  {{ selectedPeopleCount || "请选择预计人数" }}
                </span>
                <div class="w-4 h-4 flex items-center justify-center">
                  <i class="ri-arrow-down-s-line text-gray-400"></i>
                </div>
              </button>
              <div
                v-show="peopleDropdownVisible"
                class="activity-type-dropdown absolute top-full left-0 right-0 bg-white border border-gray-300 rounded-lg shadow-lg mt-1 z-10"
              >
                <div class="py-1">
                  <button
                    v-for="count in peopleCounts"
                    :key="count"
                    type="button"
                    class="activity-type-option w-full px-3 py-2 text-left text-sm hover:bg-gray-50 cursor-pointer"
                    @click="selectPeopleCount(count)"
                  >
                    {{ count }}
                  </button>
                </div>
              </div>
            </div>
          </div>
          <div>
            <label class="block text-sm font-medium text-gray-700 mb-2"
              >开始日期 <span class="text-red-500">*</span></label
            >
            <input
              type="date"
              v-model="startDate"
              class="w-full px-3 py-2 border border-gray-300 rounded-lg text-sm focus:ring-2 focus:ring-primary focus:border-transparent"
              :min="today"
              @change="onStartDateChange"
            />
          </div>
          <div>
            <label class="block text-sm font-medium text-gray-700 mb-2"
              >结束日期 <span class="text-red-500">*</span></label
            >
            <input
              type="date"
              v-model="endDate"
              class="w-full px-3 py-2 border border-gray-300 rounded-lg text-sm focus:ring-2 focus:ring-primary focus:border-transparent"
              :min="startDate"
              @change="onEndDateChange"
            />
          </div>
          <div class="col-span-2">
            <label class="block text-sm font-medium text-gray-700 mb-2"
              >活动地点 <span class="text-red-500">*</span></label
            >
            <input
              type="text"
              v-model="location"
              class="w-full px-3 py-2 border border-gray-300 rounded-lg text-sm focus:ring-2 focus:ring-primary focus:border-transparent"
              placeholder="请输入活动地点"
            />
          </div>
        </div>
      </div>

      <!-- 收货地址选择 -->
      <div
        class="bg-white rounded-xl shadow-sm border border-gray-100 p-6 mb-6"
      >
        <div class="flex justify-between items-center mb-4">
          <h2 class="text-lg font-semibold text-gray-900">收货地址</h2>
          <button
            type="button"
            class="text-gray-600 hover:text-secondary text-sm flex items-center"
            @click="goToAddressManagement"
          >
            新增地址
          </button>
        </div>

        <div class="space-y-3" v-if="addresses && addresses.length > 0">
          <div
            v-for="address in addresses"
            :key="address.id"
            class="address-item p-4 border border-gray-200 rounded-lg cursor-pointer hover:border-primary transition-colors"
            :class="{
              'border-primary bg-blue-50':
                selectedAddress && selectedAddress.id === address.id,
            }"
            @click="selectAddress(address)"
          >
            <div class="flex items-center justify-between mb-2">
              <div class="flex items-center">
                <div
                  class="address-radio w-5 h-5 border-2 rounded-full mr-3 flex items-center justify-center"
                  :class="{
                    'border-primary':
                      selectedAddress && selectedAddress.id === address.id,
                  }"
                >
                  <div
                    class="w-3 h-3 bg-primary rounded-full"
                    :class="{
                      hidden:
                        !selectedAddress || selectedAddress.id !== address.id,
                    }"
                  ></div>
                </div>
                <span class="font-medium">{{ address.name }}</span>
                <span class="ml-3 text-gray-600">{{
                  formatPhone(address.phone)
                }}</span>
                <span
                  v-if="address.isDefault"
                  class="ml-3 text-xs px-1.5 py-0.5 bg-blue-100 text-primary rounded"
                  >默认</span
                >
              </div>
            </div>
            <div class="text-gray-600 ml-8">
              {{ address.province }}{{ address.city }}{{ address.district
              }}{{ address.detail }}
            </div>
          </div>
        </div>
        <div v-else class="text-center py-6 text-gray-500">
          暂无收货地址，请点击"新增收货地址"按钮添加
        </div>
      </div>

      <!-- 预订详情 -->
      <div
        class="bg-white rounded-xl shadow-sm border border-gray-100 p-6 mb-6"
      >
        <h2 class="text-lg font-semibold text-gray-900 mb-4">预订详情</h2>
        <div class="space-y-4">
          <!-- 设备列表 -->
          <div class="border border-gray-200 rounded-lg p-4">
            <div class="flex items-center justify-between mb-3">
              <h3 class="font-medium text-gray-900">租赁设备</h3>
              <span class="text-md text-gray-500" v-if="startDate && endDate"
                >租期：{{ startDate }} 至 {{ endDate }}（{{
                  calculateDays()
                }}天）</span
              >
            </div>
            <div
              class="space-y-3"
              v-if="selectedItems && selectedItems.length > 0"
            >
              <div
                class="flex items-center justify-between py-3 border-b border-gray-100"
                v-for="item in selectedItems"
                :key="item.id"
              >
                <div class="flex items-center">
                  <img
                    :src="
                      item.thumbnail_url ||
                      item.image ||
                      'https://via.placeholder.com/60'
                    "
                    :alt="item.name"
                    class="w-12 h-12 object-cover object-top rounded-lg mr-3"
                  />
                  <div>
                    <h4 class="font-medium text-gray-900 text-sm">
                      {{ item.name }}
                    </h4>
                    <p class="text-xs text-gray-500">
                      {{ item.spec_text || "" }}
                    </p>
                  </div>
                </div>
                <div class="text-right">
                  <div class="text-sm text-gray-600">
                    ¥{{ parseFloat(item.price).toFixed(2) }}/天 ×
                    {{ item.quantity || 1 }}件 × {{ calculateDays() }}天
                  </div>
                  <div class="font-semibold text-primary">
                    ¥{{ calculateItemTotal(item).toFixed(2) }}
                  </div>
                </div>
              </div>
            </div>
            <div v-else class="text-center py-6 text-gray-500">
              暂无租赁设备
            </div>
          </div>

          <!-- 费用汇总 -->
          <div class="border-t border-gray-200 pt-4">
            <div class="flex justify-between items-center">
              <div class="flex items-center gap-4">
                <span class="text-lg font-semibold text-gray-900"
                  >租赁总计</span
                >
              </div>
              <span class="text-2xl font-bold text-primary"
                >¥{{ totalAmount }}</span
              >
            </div>
          </div>
        </div>
      </div>



      <!-- 底部确认区域 -->
      <div class="bg-white rounded-xl shadow-sm border border-gray-100 p-6">
        <div class="space-y-4">
          <!-- 条款确认 -->
          <span class="text-sm text-gray-600">
            下单前请确认以上信息无误，同意按照约定时间和地点提供租赁服务。
          </span>
          <!-- 提交按钮 -->
          <button
            id="confirm-submit"
            :class="[
              'w-full py-4 !rounded-button text-lg font-medium whitespace-nowrap transition-all duration-300',
              canSubmit
                ? 'bg-primary text-white hover:bg-primary/90 cursor-pointer'
                : 'bg-gray-300 text-gray-500 cursor-not-allowed',
            ]"
            :disabled="!canSubmit || submitting"
            @click="submitBooking"
          >
            <span v-if="submitting">
              <i class="fas fa-spinner fa-spin mr-2"></i>提交中...
            </span>
            <span v-else>确认提交订单</span>
          </button>
        </div>
      </div>
    </div>
    <!-- 使用公共页脚组件 -->
    <Footer />
  </div>
</template>

<script>
import Nav from "@/components/Nav.vue";
import Footer from "@/components/Footer.vue";
import api from "@/utils/api.js";

export default {
  name: "Confirm",
  components: {
    Nav,
    Footer,
  },
  data() {
    // 获取今天的日期，格式为YYYY-MM-DD
    const today = new Date().toISOString().split("T")[0];

    return {
      // 表单数据
      activityName: "", // 新增活动名称
      activityType: "",
      startDate: "",
      endDate: "",
      location: "",
      peopleCount: "",
      today: today,

      // 活动类型相关数据
      dropdownVisible: false,
      selectedActivityType: "",
      activityTypes: ["会议", "展览", "演出", "户外活动", "培训", "其他"],

      // 预计人数相关数据
      peopleDropdownVisible: false,
      selectedPeopleCount: "",
      peopleCounts: ["10-30 人", "30-100 人", "100-300 人", "300+ 人"],

      // 已选物品
      selectedItems: [],

      // 弹窗状态
      showItemModal: false,



      // 条款确认状态
      agreeTerms: false,

      // 收货地址相关
      addresses: [], // 从后端获取

      selectedAddress: null,
      showAddressModal: false,

      // 提交状态
      submitting: false,
    };
  },
  computed: {
    // 计算总价
    totalAmount() {
      if (!this.selectedItems || this.selectedItems.length === 0) {
        return "0.00";
      }
      const days = this.calculateDays();
      return this.selectedItems
        .reduce((total, item) => {
          return total + parseFloat(item.price) * (item.quantity || 1) * days;
        }, 0)
        .toFixed(2);
    },

    // 控制提交按钮是否可用
      canSubmit() {
        return (
          this.activityName &&
          this.activityType &&
          this.startDate &&
          this.endDate &&
          this.location &&
          this.peopleCount &&
          this.selectedItems &&
          this.selectedItems.length > 0 &&
          this.selectedAddress
        );
      },
  },
  methods: {
    // 选择收货地址
    selectAddress(address) {
      this.selectedAddress = address;
    },

    // 手机号隐私处理
    formatPhone(phone) {
      if (!phone || phone.length !== 11) {
        return phone;
      }
      return phone.replace(/(\d{3})\d{4}(\d{4})/, "$1****$2");
    },

    // 切换活动类型下拉菜单显示状态
    toggleDropdown() {
      this.dropdownVisible = !this.dropdownVisible;
      // 点击活动类型时关闭人数选择下拉菜单
      if (this.peopleDropdownVisible) {
        this.peopleDropdownVisible = false;
      }
    },

    // 切换预计人数下拉菜单显示状态
    togglePeopleDropdown() {
      this.peopleDropdownVisible = !this.peopleDropdownVisible;
      // 点击人数选择时关闭活动类型下拉菜单
      if (this.dropdownVisible) {
        this.dropdownVisible = false;
      }
    },

    // 选择活动类型
    selectActivityType(type) {
      this.selectedActivityType = type;
      this.activityType = type; // 同步到旧字段以兼容
      this.dropdownVisible = false;
    },

    // 选择预计人数
    selectPeopleCount(count) {
      this.selectedPeopleCount = count;
      this.peopleCount = count; // 同步到旧字段以兼容
      this.peopleDropdownVisible = false;
    },

    // 点击页面其他地方关闭下拉菜单
    handleClickOutside() {
      if (this.dropdownVisible) {
        this.dropdownVisible = false;
      }
      if (this.peopleDropdownVisible) {
        this.peopleDropdownVisible = false;
      }
    },

    // 开始日期变更处理
    onStartDateChange() {
      // 如果结束日期小于开始日期，则清空结束日期
      if (this.endDate && this.endDate < this.startDate) {
        this.endDate = "";
      }
    },

    // 结束日期变更处理
    onEndDateChange() {
      // 如果结束日期小于开始日期，则清空结束日期并提示
      if (this.endDate && this.startDate && this.endDate < this.startDate) {
        this.endDate = "";
        this.$message.warning("结束日期必须大于等于开始日期");
      }
    },

    // 计算租赁天数
    calculateDays() {
      if (!this.startDate || !this.endDate) {
        return 1; // 默认1天
      }
      const start = new Date(this.startDate);
      const end = new Date(this.endDate);
      const diffTime = Math.abs(end - start);
      const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24)) + 1; // 包含起止日期
      return diffDays;
    },

    // 计算单项设备总价
    calculateItemTotal(item) {
      const days = this.calculateDays();
      return parseFloat(item.price) * (item.quantity || 1) * days;
    },

    // 返回修改预订信息
    goBackToEdit() {
      // 由于快捷订单数据已经保存在localStorage中，直接返回快捷订单页面即可
      this.$router.push("/quickorder");
    },

    // 加载收货地址
    async loadAddresses() {
      try {
        const response = await api.goods.getAddressList(); // 调用地址列表API

        if (response && response.data && response.data.resdata) {
          this.addresses = response.data.resdata.map((item) => ({
            id: item.id,
            name: item.name,
            phone: item.tel, // 根据API响应字段调整
            province: item.region ? item.region.split(" ")[0] || "" : "", // 安全处理
            city: item.region ? item.region.split(" ")[1] || "" : "",
            district: item.region ? item.region.split(" ")[2] || "" : "",
            detail: item.detail,
            isDefault: item.is_default === 1, // 根据API响应调整
          }));

          // 默认选择默认地址
          if (this.addresses.length > 0) {
            const defaultAddress = this.addresses.find(
              (addr) => addr.isDefault
            );
            this.selectedAddress = defaultAddress || this.addresses[0];
          }
        } else {
          this.addresses = [];
          this.selectedAddress = null;
        }
      } catch (error) {
        console.error("获取地址列表异常:", error);
      }
    },

    // 跳转到地址管理页面
    goToAddressManagement() {
      this.$router.push("/ucenter/addresses");
    },

    // 选择收货地址
    selectAddress(address) {
      this.selectedAddress = address;
    },

    // 加载预订数据
    async loadBookingData() {
      try {
        const quickOrderData = JSON.parse(
          localStorage.getItem("quickOrderData")
        );
        if (quickOrderData) {
          // 设置活动信息
          this.activityName = quickOrderData.activityName || "";
          this.activityType = quickOrderData.activityType || "";
          this.selectedActivityType = quickOrderData.activityType || ""; // 同步到新字段
          this.startDate = quickOrderData.startDate || "";
          this.endDate = quickOrderData.endDate || "";
          this.location = quickOrderData.location || "";
          this.peopleCount = quickOrderData.peopleCount || "";
          this.selectedPeopleCount = quickOrderData.peopleCount || ""; // 同步到新字段

          // 设置选择的设备
          this.selectedItems = quickOrderData.selectedItems || [];

          console.log("加载快捷订单数据成功:", quickOrderData);
        } else {
          this.$message.warning("暂无预订数据，请先在购物车中选择商品");
        }
      } catch (error) {
        console.error("加载预订数据失败:", error);
        this.$message.error("加载预订数据失败，请刷新页面重试");
      }
    },



    // 切换条款确认状态
    toggleTermsAgreement() {
      this.agreeTerms = !this.agreeTerms;

      // 更新UI显示
      const termsInput = document.querySelector('input[name="agree_terms"]');
      const termsIndicator = document.querySelector(".terms-indicator");
      const checkIcon = termsIndicator.querySelector("i");
      const submitButton = document.getElementById("confirm-submit");

      termsInput.checked = this.agreeTerms;

      if (this.agreeTerms) {
        termsIndicator.classList.add("bg-primary", "border-primary");
        checkIcon.classList.remove("hidden");
        submitButton.classList.remove(
          "bg-gray-300",
          "text-gray-500",
          "cursor-not-allowed"
        );
        submitButton.classList.add(
          "bg-primary",
          "text-white",
          "hover:bg-secondary",
          "cursor-pointer"
        );
        submitButton.disabled = false;
      } else {
        termsIndicator.classList.remove("bg-primary", "border-primary");
        checkIcon.classList.add("hidden");
        submitButton.classList.add(
          "bg-gray-300",
          "text-gray-500",
          "cursor-not-allowed"
        );
        submitButton.classList.remove(
          "bg-primary",
          "text-white",
          "hover:bg-secondary",
          "cursor-pointer"
        );
        submitButton.disabled = true;
      }
    },

    // 提交预订
    async submitBooking() {
      // 防止重复提交
      if (this.submitting) return;

      // 设置提交中状态
      this.submitting = true;

      // 检查表单是否填写完整
      if (
        !this.activityName || // 新增检查
        !this.activityType ||
        !this.startDate ||
        !this.endDate ||
        !this.location ||
        !this.peopleCount
      ) {
        this.$message.warning("请填写完整的预订信息");
        this.submitting = false;
        return;
      }

      if (this.selectedItems.length === 0) {
        this.$message.warning("请至少选择一种租赁物品");
        this.submitting = false;
        return;
      }



      // 检查是否选择了收货地址
      if (!this.selectedAddress) {
        this.$message.warning("请选择收货地址");
        this.submitting = false;
        return;
      }

      // 构建快速预订数据
      const quickOrderData = {
        activityName: this.activityName,
        activityType: this.activityType,
        startDate: this.startDate,
        endDate: this.endDate,
        location: this.location,
        peopleCount: this.peopleCount,
        items: this.selectedItems,
        totalAmount: this.totalAmount,
        // 收货地址信息
        recipientName: this.selectedAddress.name,
        recipientPhone: this.selectedAddress.phone,
        address: `${this.selectedAddress.province}${this.selectedAddress.city}${this.selectedAddress.district}${this.selectedAddress.detail}`,
      };



      // 提交订单到后台
      try {
        const response = await api.order.createOrder(quickOrderData);

        // 提交成功后可以清除localStorage中的数据
        // localStorage.removeItem("quickOrderData");
        // 延迟跳转，让用户看到成功提示
        setTimeout(() => {
          this.$router.push({
            name: "Cashier",
            params: {
              orderNumber: response.data,
            },
          });
        }, 1000);
      } catch (error) {
        console.error("提交预订失败:", error);
      } finally {
        // 无论成功失败，都恢复提交状态
        this.submitting = false;
      }
    },
  },
  mounted() {
    // 加载预订数据
    this.loadBookingData();

    // 加载收货地址
    this.loadAddresses();

    // 点击页面其他地方关闭下拉菜单
    document.addEventListener("click", this.handleClickOutside);

    // 提交按钮事件已在模板中通过@click绑定


  },
  beforeUnmount() {
    // 清理事件监听器
    document.removeEventListener("click", this.handleClickOutside);
  },
};
</script>

<style scoped>
/* 容器样式 */
.about-container {
  min-height: 100vh;
  display: flex;
  flex-direction: column;
}

/* 活动类型和人数下拉菜单样式 */
.activity-type-select:focus {
  outline: none;
  border-color: #3b82f6;
  box-shadow: 0 0 0 2px rgba(59, 130, 246, 0.2);
}

.activity-type-dropdown {
  max-height: 200px;
  overflow-y: auto;
}

.activity-type-option:focus {
  outline: none;
  background-color: rgba(59, 130, 246, 0.1);
}

/* 下拉菜单显示样式 */
.activity-type-dropdown.show,
.people-count-dropdown.show {
  display: block !important;
}



/* 地址选择样式 */
.address-item {
  transition: all 0.2s;
}

.address-item:hover {
  border-color: #1677ff;
}

.address-item.border-primary {
  border-color: #1677ff;
}

/* 条款复选框选中样式 */
.terms-indicator.bg-primary {
  background-color: #1677ff !important;
  border-color: #1677ff !important;
}

/* 提交按钮可用状态 */
#confirm-submit.bg-primary {
  background-color: #1677ff !important;
  color: white !important;
  cursor: pointer !important;
}

#confirm-submit.bg-primary:hover {
  background-color: #0958d9 !important;
}
</style>



// WEBPACK FOOTER //
// src/pages/order/Confirm.vue